export enum GrantsRoles {
  ACCOUNT_GRANTS_VIEWER = 'roles.accountGrantsViewer',
  ACCOUNT_GRANTS_MANAGER = 'roles.accountGrantsManager',
  GRANT_PAYMENT_MANAGER = 'roles.grantPaymentManager',
}
